import { render } from "./sclfdzView.vue?vue&type=template&id=54de64c1"
import script from "./sclfdzView.vue?vue&type=script&lang=js"
export * from "./sclfdzView.vue?vue&type=script&lang=js"

import "./sclfdzView.vue?vue&type=style&index=0&id=54de64c1&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__